import { render, staticRenderFns } from "./approvedText.vue?vue&type=template&id=ef51a780&"
import script from "./approvedText.vue?vue&type=script&lang=ts&"
export * from "./approvedText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports